import { FSharpRef, Union, Record } from "../fable_modules/fable-library-js.4.28.0/Types.js";
import { union_type, record_type, int32_type, list_type, string_type } from "../fable_modules/fable-library-js.4.28.0/Reflection.js";
import { AgeCategory, Gender, AgeCategory_$reflection, Gender_$reflection } from "./Types.js";
import { empty, tryFind, add, foldBack, ofList } from "../fable_modules/fable-library-js.4.28.0/Map.js";
import { singleton, map as map_1, filter, empty as empty_1, reverse, append, cons, tail as tail_1, head, isEmpty, exists, ofArray } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { equals, comparePrimitives } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { split, join } from "../fable_modules/fable-library-js.4.28.0/String.js";
import { map } from "../fable_modules/fable-library-js.4.28.0/Array.js";
import { tryParse } from "../fable_modules/fable-library-js.4.28.0/Int32.js";

export class QuickAddResult extends Record {
    constructor(FirstName, LastName, Title, Gender, AgeCategory, Tags, PlusN) {
        super();
        this.FirstName = FirstName;
        this.LastName = LastName;
        this.Title = Title;
        this.Gender = Gender;
        this.AgeCategory = AgeCategory;
        this.Tags = Tags;
        this.PlusN = (PlusN | 0);
    }
}

export function QuickAddResult_$reflection() {
    return record_type("Shared.QuickAddParser.QuickAddResult", [], QuickAddResult, () => [["FirstName", string_type], ["LastName", string_type], ["Title", string_type], ["Gender", Gender_$reflection()], ["AgeCategory", AgeCategory_$reflection()], ["Tags", list_type(string_type)], ["PlusN", int32_type]]);
}

class KeywordType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GenderKeyword", "AgeKeyword"];
    }
}

function KeywordType_$reflection() {
    return union_type("Shared.QuickAddParser.KeywordType", [], KeywordType, () => [[["Item", Gender_$reflection()]], [["Item", AgeCategory_$reflection()]]]);
}

const englishKeywords = ofList(ofArray([["male", new KeywordType(0, [new Gender(0, [])])], ["female", new KeywordType(0, [new Gender(1, [])])], ["man", new KeywordType(0, [new Gender(0, [])])], ["woman", new KeywordType(0, [new Gender(1, [])])], ["nonbinary", new KeywordType(0, [new Gender(2, [])])], ["nb", new KeywordType(0, [new Gender(2, [])])], ["child", new KeywordType(1, [new AgeCategory(0, [])])], ["teen", new KeywordType(1, [new AgeCategory(1, [])])], ["senior", new KeywordType(1, [new AgeCategory(3, [])])]]), {
    Compare: comparePrimitives,
});

const localizedKeywords = ofList(ofArray([["sv", ofList(ofArray([["man", new KeywordType(0, [new Gender(0, [])])], ["kvinna", new KeywordType(0, [new Gender(1, [])])], ["ickebinär", new KeywordType(0, [new Gender(2, [])])], ["barn", new KeywordType(1, [new AgeCategory(0, [])])], ["tonåring", new KeywordType(1, [new AgeCategory(1, [])])], ["senior", new KeywordType(1, [new AgeCategory(3, [])])]]), {
    Compare: comparePrimitives,
})], ["de", ofList(ofArray([["männlich", new KeywordType(0, [new Gender(0, [])])], ["weiblich", new KeywordType(0, [new Gender(1, [])])], ["mann", new KeywordType(0, [new Gender(0, [])])], ["frau", new KeywordType(0, [new Gender(1, [])])], ["nichtbinär", new KeywordType(0, [new Gender(2, [])])], ["kind", new KeywordType(1, [new AgeCategory(0, [])])], ["jugendlicher", new KeywordType(1, [new AgeCategory(1, [])])], ["senior", new KeywordType(1, [new AgeCategory(3, [])])]]), {
    Compare: comparePrimitives,
})], ["fr", ofList(ofArray([["homme", new KeywordType(0, [new Gender(0, [])])], ["femme", new KeywordType(0, [new Gender(1, [])])], ["masculin", new KeywordType(0, [new Gender(0, [])])], ["féminin", new KeywordType(0, [new Gender(1, [])])], ["nonbinaire", new KeywordType(0, [new Gender(2, [])])], ["enfant", new KeywordType(1, [new AgeCategory(0, [])])], ["ado", new KeywordType(1, [new AgeCategory(1, [])])], ["adolescent", new KeywordType(1, [new AgeCategory(1, [])])], ["sénior", new KeywordType(1, [new AgeCategory(3, [])])]]), {
    Compare: comparePrimitives,
})], ["es", ofList(ofArray([["hombre", new KeywordType(0, [new Gender(0, [])])], ["mujer", new KeywordType(0, [new Gender(1, [])])], ["masculino", new KeywordType(0, [new Gender(0, [])])], ["femenino", new KeywordType(0, [new Gender(1, [])])], ["nobinario", new KeywordType(0, [new Gender(2, [])])], ["niño", new KeywordType(1, [new AgeCategory(0, [])])], ["niña", new KeywordType(1, [new AgeCategory(0, [])])], ["adolescente", new KeywordType(1, [new AgeCategory(1, [])])], ["mayor", new KeywordType(1, [new AgeCategory(3, [])])]]), {
    Compare: comparePrimitives,
})], ["it", ofList(ofArray([["uomo", new KeywordType(0, [new Gender(0, [])])], ["donna", new KeywordType(0, [new Gender(1, [])])], ["maschile", new KeywordType(0, [new Gender(0, [])])], ["femminile", new KeywordType(0, [new Gender(1, [])])], ["nonbinario", new KeywordType(0, [new Gender(2, [])])], ["bambino", new KeywordType(1, [new AgeCategory(0, [])])], ["bambina", new KeywordType(1, [new AgeCategory(0, [])])], ["adolescente", new KeywordType(1, [new AgeCategory(1, [])])], ["anziano", new KeywordType(1, [new AgeCategory(3, [])])]]), {
    Compare: comparePrimitives,
})], ["pt", ofList(ofArray([["homem", new KeywordType(0, [new Gender(0, [])])], ["mulher", new KeywordType(0, [new Gender(1, [])])], ["masculino", new KeywordType(0, [new Gender(0, [])])], ["feminino", new KeywordType(0, [new Gender(1, [])])], ["naobinario", new KeywordType(0, [new Gender(2, [])])], ["criança", new KeywordType(1, [new AgeCategory(0, [])])], ["adolescente", new KeywordType(1, [new AgeCategory(1, [])])], ["idoso", new KeywordType(1, [new AgeCategory(3, [])])]]), {
    Compare: comparePrimitives,
})], ["nb", ofList(ofArray([["mann", new KeywordType(0, [new Gender(0, [])])], ["kvinne", new KeywordType(0, [new Gender(1, [])])], ["ikkebinær", new KeywordType(0, [new Gender(2, [])])], ["barn", new KeywordType(1, [new AgeCategory(0, [])])], ["ungdom", new KeywordType(1, [new AgeCategory(1, [])])], ["senior", new KeywordType(1, [new AgeCategory(3, [])])]]), {
    Compare: comparePrimitives,
})], ["pl", ofList(ofArray([["mężczyzna", new KeywordType(0, [new Gender(0, [])])], ["kobieta", new KeywordType(0, [new Gender(1, [])])], ["niebinarny", new KeywordType(0, [new Gender(2, [])])], ["dziecko", new KeywordType(1, [new AgeCategory(0, [])])], ["nastolatek", new KeywordType(1, [new AgeCategory(1, [])])], ["senior", new KeywordType(1, [new AgeCategory(3, [])])]]), {
    Compare: comparePrimitives,
})], ["nl", ofList(ofArray([["man", new KeywordType(0, [new Gender(0, [])])], ["vrouw", new KeywordType(0, [new Gender(1, [])])], ["nonbinair", new KeywordType(0, [new Gender(2, [])])], ["kind", new KeywordType(1, [new AgeCategory(0, [])])], ["tiener", new KeywordType(1, [new AgeCategory(1, [])])], ["senior", new KeywordType(1, [new AgeCategory(3, [])])]]), {
    Compare: comparePrimitives,
})], ["da", ofList(ofArray([["mand", new KeywordType(0, [new Gender(0, [])])], ["kvinde", new KeywordType(0, [new Gender(1, [])])], ["ikkebinær", new KeywordType(0, [new Gender(2, [])])], ["barn", new KeywordType(1, [new AgeCategory(0, [])])], ["teenager", new KeywordType(1, [new AgeCategory(1, [])])], ["senior", new KeywordType(1, [new AgeCategory(3, [])])]]), {
    Compare: comparePrimitives,
})], ["hu", ofList(ofArray([["férfi", new KeywordType(0, [new Gender(0, [])])], ["nő", new KeywordType(0, [new Gender(1, [])])], ["nembináris", new KeywordType(0, [new Gender(2, [])])], ["gyerek", new KeywordType(1, [new AgeCategory(0, [])])], ["tinédzser", new KeywordType(1, [new AgeCategory(1, [])])], ["idős", new KeywordType(1, [new AgeCategory(3, [])])]]), {
    Compare: comparePrimitives,
})], ["hr", ofList(ofArray([["muškarac", new KeywordType(0, [new Gender(0, [])])], ["žena", new KeywordType(0, [new Gender(1, [])])], ["nebinarno", new KeywordType(0, [new Gender(2, [])])], ["dijete", new KeywordType(1, [new AgeCategory(0, [])])], ["tinejdžer", new KeywordType(1, [new AgeCategory(1, [])])], ["senior", new KeywordType(1, [new AgeCategory(3, [])])]]), {
    Compare: comparePrimitives,
})], ["cs", ofList(ofArray([["muž", new KeywordType(0, [new Gender(0, [])])], ["žena", new KeywordType(0, [new Gender(1, [])])], ["nebinární", new KeywordType(0, [new Gender(2, [])])], ["dítě", new KeywordType(1, [new AgeCategory(0, [])])], ["teenager", new KeywordType(1, [new AgeCategory(1, [])])], ["senior", new KeywordType(1, [new AgeCategory(3, [])])]]), {
    Compare: comparePrimitives,
})], ["ro", ofList(ofArray([["bărbat", new KeywordType(0, [new Gender(0, [])])], ["femeie", new KeywordType(0, [new Gender(1, [])])], ["nebinar", new KeywordType(0, [new Gender(2, [])])], ["copil", new KeywordType(1, [new AgeCategory(0, [])])], ["adolescent", new KeywordType(1, [new AgeCategory(1, [])])], ["senior", new KeywordType(1, [new AgeCategory(3, [])])]]), {
    Compare: comparePrimitives,
})], ["sk", ofList(ofArray([["muž", new KeywordType(0, [new Gender(0, [])])], ["žena", new KeywordType(0, [new Gender(1, [])])], ["nebinárny", new KeywordType(0, [new Gender(2, [])])], ["dieťa", new KeywordType(1, [new AgeCategory(0, [])])], ["tínedžer", new KeywordType(1, [new AgeCategory(1, [])])], ["senior", new KeywordType(1, [new AgeCategory(3, [])])]]), {
    Compare: comparePrimitives,
})], ["bg", ofList(ofArray([["мъж", new KeywordType(0, [new Gender(0, [])])], ["жена", new KeywordType(0, [new Gender(1, [])])], ["небинарен", new KeywordType(0, [new Gender(2, [])])], ["дете", new KeywordType(1, [new AgeCategory(0, [])])], ["тийнейджър", new KeywordType(1, [new AgeCategory(1, [])])], ["възрастен", new KeywordType(1, [new AgeCategory(3, [])])]]), {
    Compare: comparePrimitives,
})], ["el", ofList(ofArray([["άνδρας", new KeywordType(0, [new Gender(0, [])])], ["γυναίκα", new KeywordType(0, [new Gender(1, [])])], ["μηδυαδικό", new KeywordType(0, [new Gender(2, [])])], ["παιδί", new KeywordType(1, [new AgeCategory(0, [])])], ["έφηβος", new KeywordType(1, [new AgeCategory(1, [])])], ["ηλικιωμένος", new KeywordType(1, [new AgeCategory(3, [])])]]), {
    Compare: comparePrimitives,
})], ["tr", ofList(ofArray([["erkek", new KeywordType(0, [new Gender(0, [])])], ["kadın", new KeywordType(0, [new Gender(1, [])])], ["ikiliölmayan", new KeywordType(0, [new Gender(2, [])])], ["çocuk", new KeywordType(1, [new AgeCategory(0, [])])], ["ergen", new KeywordType(1, [new AgeCategory(1, [])])], ["yaşlı", new KeywordType(1, [new AgeCategory(3, [])])]]), {
    Compare: comparePrimitives,
})]]), {
    Compare: comparePrimitives,
});

function keywordsForLang(lang) {
    let matchValue;
    return foldBack(add, (matchValue = tryFind((lang.length >= 2) ? lang.slice(0, 1 + 1).toLowerCase() : "en", localizedKeywords), (matchValue == null) ? empty({
        Compare: comparePrimitives,
    }) : matchValue), englishKeywords);
}

const titles = ofArray(["Mr.", "Mrs.", "Ms.", "Dr.", "Prof.", "Sir", "Rev."]);

function isTitle(word) {
    return exists((t) => (t.toLowerCase() === word.toLowerCase()), titles);
}

function titleCaseWord(w) {
    if (w.length === 0) {
        return w;
    }
    else {
        return w[0].toLocaleUpperCase() + w.slice(1, w.length).toLowerCase();
    }
}

function titleCase(s) {
    return join(" ", map(titleCaseWord, split(s, [" "], undefined, 0)));
}

function tryParsePlusN(word) {
    if ((word.length >= 2) && (word[0] === "+")) {
        let matchValue;
        let outArg = 0;
        matchValue = [tryParse(word.slice(1, word.length), 511, false, 32, new FSharpRef(() => outArg, (v) => {
            outArg = (v | 0);
        })), outArg];
        let matchResult;
        if (matchValue[0]) {
            if (matchValue[1] >= 0) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return matchValue[1];
            default:
                return undefined;
        }
    }
    else {
        return undefined;
    }
}

function extractPlusN(words) {
    const loop = (acc_mut, rest_mut) => {
        loop:
        while (true) {
            const acc = acc_mut, rest = rest_mut;
            if (!isEmpty(rest)) {
                const w = head(rest);
                const tail = tail_1(rest);
                const matchValue = tryParsePlusN(w);
                if (matchValue == null) {
                    acc_mut = cons(w, acc);
                    rest_mut = tail;
                    continue loop;
                }
                else {
                    return [matchValue, append(reverse(acc), tail)];
                }
            }
            else {
                return [0, reverse(acc)];
            }
            break;
        }
    };
    return loop(empty_1(), words);
}

/**
 * Parse quick-add input into structured result.
 * If input contains '#', uses backward-compatible #-tag parsing.
 * Otherwise, scans for gender/age keywords and treats remaining words as tag.
 */
export function parseQuickAdd(lang, input) {
    const trimmed = input.trim();
    if (trimmed === "") {
        return undefined;
    }
    else if (trimmed.indexOf("#") >= 0) {
        const parts = ofArray(split(trimmed, ["#"], undefined, 0));
        const namePart = isEmpty(parts) ? "" : head(parts).trim();
        const tags = isEmpty(parts) ? empty_1() : filter((t_1) => (t_1 !== ""), map_1((t) => t.trim(), tail_1(parts)));
        if (namePart === "") {
            return undefined;
        }
        else {
            const words = ofArray(split(namePart, [" "], undefined, 0));
            if (isEmpty(words)) {
                return undefined;
            }
            else {
                const patternInput = extractPlusN(words);
                const wordsWithoutPlusN = patternInput[1];
                const patternInput_1 = !isEmpty(wordsWithoutPlusN) ? (isTitle(head(wordsWithoutPlusN)) ? [head(wordsWithoutPlusN), tail_1(wordsWithoutPlusN)] : ["", wordsWithoutPlusN]) : ["", wordsWithoutPlusN];
                const nameWords = patternInput_1[1];
                const patternInput_2 = !isEmpty(nameWords) ? (isEmpty(tail_1(nameWords)) ? [head(nameWords), ""] : [head(nameWords), join(" ", tail_1(nameWords))]) : ["", ""];
                const lastName = patternInput_2[1];
                const firstName = patternInput_2[0];
                if ((firstName === "") && (lastName === "")) {
                    return undefined;
                }
                else {
                    return new QuickAddResult(firstName, lastName, patternInput_1[0], new Gender(3, []), new AgeCategory(2, []), tags, patternInput[0]);
                }
            }
        }
    }
    else {
        const keywords = keywordsForLang(lang);
        const patternInput_3 = extractPlusN(filter((w_2) => (w_2 !== ""), ofArray(split(trimmed, [" "], undefined, 0))));
        const wordsWithoutPlusN_1 = patternInput_3[1];
        const patternInput_4 = !isEmpty(wordsWithoutPlusN_1) ? (isTitle(head(wordsWithoutPlusN_1)) ? [head(wordsWithoutPlusN_1), tail_1(wordsWithoutPlusN_1)] : ["", wordsWithoutPlusN_1]) : ["", wordsWithoutPlusN_1];
        const title_1 = patternInput_4[0];
        const scan = (nameAcc_mut, gender_mut, age_mut, tagWords_mut, ws_mut, foundKeyword_mut) => {
            scan:
            while (true) {
                const nameAcc = nameAcc_mut, gender = gender_mut, age = age_mut, tagWords = tagWords_mut, ws = ws_mut, foundKeyword = foundKeyword_mut;
                if (!isEmpty(ws)) {
                    const w_5 = head(ws);
                    const rest_5 = tail_1(ws);
                    const matchValue = tryFind(w_5.toLowerCase(), keywords);
                    if (matchValue == null) {
                        if (foundKeyword) {
                            nameAcc_mut = nameAcc;
                            gender_mut = gender;
                            age_mut = age;
                            tagWords_mut = cons(w_5, tagWords);
                            ws_mut = rest_5;
                            foundKeyword_mut = true;
                            continue scan;
                        }
                        else {
                            nameAcc_mut = cons(w_5, nameAcc);
                            gender_mut = gender;
                            age_mut = age;
                            tagWords_mut = tagWords;
                            ws_mut = rest_5;
                            foundKeyword_mut = false;
                            continue scan;
                        }
                    }
                    else if (matchValue.tag === 1) {
                        const a = matchValue.fields[0];
                        nameAcc_mut = nameAcc;
                        gender_mut = gender;
                        age_mut = (equals(age, new AgeCategory(2, [])) ? a : age);
                        tagWords_mut = tagWords;
                        ws_mut = rest_5;
                        foundKeyword_mut = true;
                        continue scan;
                    }
                    else {
                        const g = matchValue.fields[0];
                        nameAcc_mut = nameAcc;
                        gender_mut = (equals(gender, new Gender(3, [])) ? g : gender);
                        age_mut = age;
                        tagWords_mut = tagWords;
                        ws_mut = rest_5;
                        foundKeyword_mut = true;
                        continue scan;
                    }
                }
                else {
                    return [reverse(nameAcc), gender, age, reverse(tagWords)];
                }
                break;
            }
        };
        const patternInput_5 = scan(empty_1(), new Gender(3, []), new AgeCategory(2, []), empty_1(), patternInput_4[1], false);
        const tagWords_1 = patternInput_5[3];
        const nameWords_1 = patternInput_5[0];
        const patternInput_6 = !isEmpty(nameWords_1) ? (isEmpty(tail_1(nameWords_1)) ? [head(nameWords_1), ""] : [head(nameWords_1), join(" ", tail_1(nameWords_1))]) : ["", ""];
        const lastName_1 = patternInput_6[1];
        const firstName_1 = patternInput_6[0];
        if (((firstName_1 === "") && (lastName_1 === "")) && (title_1 === "")) {
            return undefined;
        }
        else {
            return new QuickAddResult(firstName_1, lastName_1, title_1, patternInput_5[1], patternInput_5[2], isEmpty(tagWords_1) ? empty_1() : singleton(titleCase(join(" ", tagWords_1))), patternInput_3[0]);
        }
    }
}

